"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSnackbar = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const Alert_1 = __importDefault(require("@material-ui/lab/Alert"));
const AppSnackbar = props => {
    const { open, severity, children, onClose } = props;
    const [openSnackbar, setOpenSnackbar] = (0, react_1.useState)(open);
    const handleClose = () => {
        setOpenSnackbar(false);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    (0, react_1.useEffect)(() => {
        setOpenSnackbar(open);
    }, [open]);
    return (react_1.default.createElement(core_1.Snackbar, { anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, open: openSnackbar, autoHideDuration: 5000, onClose: handleClose },
        react_1.default.createElement(Alert_1.default, { severity: severity || 'info', elevation: 6, variant: 'filled', onClose: handleClose }, children)));
};
exports.AppSnackbar = AppSnackbar;
exports.default = exports.AppSnackbar;
//# sourceMappingURL=AppSnackbar.js.map